import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { showAddressDialog, hideAddressDialog } from '../store/actions/addressDialog.actions';

export const useAddressDialog = () => {
  const dispatch = useDispatch();
  const { savedResult, deletedResult } = useSelector((state) => state.addressDialog);
  const pendingRequest = useRef(null);

  useEffect(() => {
    const request = pendingRequest.current;
    if (!request || savedResult?.requestId !== request.requestId) return;
    const callback = savedResult.isEditMode ? request.onAddressUpdated : request.onAddressCreated;
    callback?.(savedResult.address);
  }, [savedResult]);

  useEffect(() => {
    const request = pendingRequest.current;
    if (request && deletedResult?.requestId === request.requestId)
      request.onAddressDeleted?.(deletedResult.addressId);
  }, [deletedResult]);

  const openAddressDialog = useCallback(
    (addressId = null, options = {}) => {
      const requestId = uuid();
      pendingRequest.current = { ...options, requestId };
      dispatch(
        showAddressDialog({
          addressId,
          requestId,
          closeOnSave: options.closeOnSave,
          copyFromAddressId: options.copyFromAddressId,
        })
      );
    },
    [dispatch]
  );

  const closeAddressDialog = useCallback((requestId) => dispatch(hideAddressDialog(requestId)), [
    dispatch,
  ]);

  return { openAddressDialog, closeAddressDialog };
};
